import { Group, Stack, Text } from '@mantine/core'

import type { PredictionContract } from '@/services/prediction/types'

import { CompetitorLogo } from '../_shared/CompetitorLogo'
import { WinChanceBar } from '../_shared/WinChanceBar'
import type { OutcomeVisuals } from './resolveOutcomeVisuals'

/** Streamline 前导视觉密度（Figma 2466-105541）：40px 圆角 8，比旧版 28px badge 大。 */
const LOGO_SIZE = 40
const LOGO_RADIUS = 8

interface OutcomeIdentityProps {
  contract: PredictionContract
  visuals: OutcomeVisuals
  /** percentage 布局：名字下渲染胜率比例条。 */
  showUnderline?: boolean
  /** 0–100 隐含概率，驱动下划线填充。 */
  chancePct?: number | null
}

/**
 * Port of cdc-web `FutureCard/OutcomeRow.tsx` 的 `OutcomeIdentity`：一行
 * outcome 的前导视觉 + 名字（卡片共享 grid 的左列）。价格格由父级
 * FutureCard 持有，跨行共享列宽。`hideLogo` 时前导视觉整列省略（名字顶格）。
 */
export function OutcomeIdentity({
  contract,
  visuals,
  showUnderline = false,
  chancePct,
}: Readonly<OutcomeIdentityProps>) {
  return (
    <Group gap="xs" wrap="nowrap" style={{ minWidth: 0, flex: '1 1 0' }}>
      {!visuals.hideLogo && (
        <CompetitorLogo
          size={LOGO_SIZE}
          radius={LOGO_RADIUS}
          primaryColor={visuals.primaryColor}
          playerImage={visuals.playerImage}
          logoUrl={visuals.logoUrl}
          fallbackText={visuals.fallbackText}
        />
      )}
      <Stack gap={showUnderline ? 6 : 0} style={{ flex: '1 1 0', minWidth: 0, overflow: 'hidden' }}>
        <Text
          variant="body-emphasis"
          c="var(--content-primary)"
          truncate
          style={{
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {contract.contract_title}
        </Text>
        {showUnderline && <WinChanceBar color={visuals.primaryColor} chancePct={chancePct} />}
      </Stack>
    </Group>
  )
}
